import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { FooterComponent } from '../../layout/footer/footer.component';
import { HeaderComponent } from '../../layout/header/header.component';
import {
  IdentificationCardComponent,
  IdentificationCardVariant,
} from '../../shared/components/identification-card/identification-card.component';
import { VisitService } from '../../core/visit/visit.service';
import { HardwareConfigService } from '../../core/hardware/hardware-config.service';

interface IdentificationOption {
  variant: IdentificationCardVariant;
  title: string;
  subtitle: string;
  illustrationSrc: string;
  illustrationAlt: string;
}

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [HeaderComponent, FooterComponent, IdentificationCardComponent],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
})
export class HomeComponent {
  private readonly router         = inject(Router);
  private readonly visitService   = inject(VisitService);
  private readonly hardwareConfig = inject(HardwareConfigService);

  readonly showDocuments = (): boolean => this.hardwareConfig.isChoiceActive('DOCUMENT');

  /**
   * Arrivée à gauche, départ à droite : sens de lecture, l'arrivée précède le
   * départ dans le temps et représente le volume d'usage majoritaire.
   */
  readonly identificationOptions: IdentificationOption[] = [
    {
      variant: 'arrival',
      title: 'Signaler mon arrivée',
      subtitle: "S'identifier avec ou sans QR code",
      illustrationSrc: 'assets/img/icon-illustration-arrival.svg',
      illustrationAlt: 'Personne entrant dans le bâtiment',
    },
    {
      variant: 'departure',
      title: 'Signaler mon départ',
      subtitle: 'Check-out de votre visite',
      illustrationSrc: 'assets/img/icon-illustration-departure.svg',
      illustrationAlt: 'Personne quittant le bâtiment',
    },
    {
      variant: 'documents',
      title: 'Consulter nos documents',
      subtitle: 'Informations & consignes',
      illustrationSrc: '',
      illustrationAlt: 'Icône document',
    },
  ];

  async onCardPressed(variant: IdentificationCardVariant): Promise<void> {
    switch (variant) {
      case 'arrival':
        this.visitService.ensureVisit();
        // Le mode d'identification n'est plus connu ici : il est choisi à
        // l'écran suivant, qui pose `entryMethod` et l'événement associé.
        void this.router.navigate(['/identification-mode/checkin']);
        break;
      case 'departure':
        // Le départ n'est PAS une session borne (SPECS §6) : on ne démarre
        // aucune visite. On clôture au contraire celle qui traîne, ce qui la
        // rend immédiatement trouvable au check-out sans attendre le timeout.
        if (this.visitService.current()) {
          await this.visitService.endVisit('Auto');
        }
        void this.router.navigate(['/identification-mode/checkout']);
        break;
      case 'documents':
        this.visitService.ensureVisit();
        this.visitService.trackEvent('document_browsing');
        void this.router.navigate(['/document-selection']);
        break;
    }
  }
}
